import React from "react";
import { Button, Icon } from "@sicredi/react";
import { useIsAuthenticated } from "#/hooks/useIsAuthenticated";

export const Navbar: React.FC = () => {
  const { logoff } = useIsAuthenticated();

  return (
    <div className="navbar">
      <Button data-testid="logoutBtn" onClick={() => logoff()}>
        <Icon name="exit" />
        Sair
      </Button>
    </div>
  );
};

export default Navbar;
